// components/genre/GenreAnalytics.jsx
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const GenreAnalytics = ({ analytics }) => {
    if (!analytics) return null;

    return (
        <>
            {/* Price Distribution */}
            <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-semibold mb-4">Price Distribution</h3>
                <div className="h-64">
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie
                                data={Object.entries(analytics.priceDistribution).map(([range, count]) => ({
                                    name: range,
                                    value: count
                                }))}
                                dataKey="value"
                                nameKey="name"
                                innerRadius={60}
                                outerRadius={80}
                            >
                                {Object.entries(analytics.priceDistribution).map((entry, index) => (
                                    <Cell key={index} fill={`hsl(${index * 30}, 70%, 50%)`} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* Revenue Metrics */}
            <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-semibold mb-4">Revenue Metrics</h3>
                <div className="grid grid-cols-2 gap-4">
                    <div className="p-4 bg-blue-50 rounded-lg">
                        <p className="text-sm text-blue-600">Average Price</p>
                        <p className="text-2xl font-bold">${analytics.averagePrice.toFixed(2)}</p>
                    </div>
                    <div className="p-4 bg-green-50 rounded-lg">
                        <p className="text-sm text-green-600">Total Revenue</p>
                        <p className="text-2xl font-bold">${(analytics.totalRevenue / 1000000).toFixed(1)}M</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GenreAnalytics;